module.exports = __webpack_public_path__ + "static/media/threeCircles.0fa65aa9.svg";